import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Add16 } from 'ui/icons/action/Add16';
import { useModalContext } from 'utils/contexts/modal';
import { MODAL_ACTION, ModalState } from './ApiKeyModal.constants';

export const PAGE_ACTIONS_TEXT = {
  createButtonId: 'new-api-key-btn',
  createButtonLabel: 'New API key',
};

export const PageActions = () => {
  const { showModal } = useModalContext<ModalState>();

  return (
    <PrimaryButton
      id={PAGE_ACTIONS_TEXT.createButtonId}
      onClick={() => {
        showModal({ action: MODAL_ACTION.CREATE_API_KEY });
      }}
      size={BUTTON_SIZES.LARGE}
    >
      <Add16 />
      <span>{PAGE_ACTIONS_TEXT.createButtonLabel}</span>
    </PrimaryButton>
  );
};
